module.exports = __webpack_public_path__ + "static/media/connectino-logo-fa-blue.22418316.svg";